<template>
    <div class="searchbar mb-2">
        <v-text-field
            class="v-input-field--search"
            outlined
            clearable
            dense
            :placeholder="placeHolder"
            v-model="search"
            @keyup.enter="emitter()"
            @click:clear="clear()"
        />
        <v-btn dense class="button" @click="emitter()">
            <v-icon small> mdi-magnify </v-icon>
        </v-btn>
    </div>
</template>

<script>
export default {
    data(){
        return{
            search:"",
        }
    },
    watch:{
        search(newValue,oldValue){
            this.$emit("change",newValue)
            if(oldValue.length >0 && newValue.length<=0){
                this.clear();
            }
        }
    },
    mounted(){
        this.search = localStorage.searching ? localStorage.searching : "";
    },
    methods:{
        emitter(){
            this.$emit("search",this.search)
        },
        clear()
        {
            this.search='';
            this.$emit('clear')
        }
    },
    props: {
        placeHolder: {
            type: String,
            default: "Nombre, Estado, Tipo, Estrategia"
        }
    }

}
</script>
